export default "query GetFileCookies {\n  getFileCookies {\n    signature\n    keyPairId\n    policy\n  }\n}"